<template>
  <div ref="chart" id="main" style="width: 140px; height: 140px"></div>
</template>

<script>
import * as echarts from "echarts";
export default {
  name: "chart",
  props: ["preData"],
  data() {
    return {
      chart: null,
    };
  },
  computed: {
    chartPieOption() {
      return {
        title: {
          text: this.preData.title || "",
          textStyle: {
            color: "#555555",
            fontSize: 16,
            fontFamily: "Microsoft YaHei",
            align: "right",
          },
        },
        series: [
          {
            type: "pie",
            color: this.preData.show ? ["#5470c6", "#91cc75", "#fac858", "#ee6666", "#73c0de", "#3ba272", "#fc8452", "#9a60b4", "#ea7ccc"] : ["#FA7369", "#F0F0F0"],
            top: 20,
            radius: ["60%", "100%"],
            center: ["50%", "50%"],
            data: this.preData.typeList,
            label: {
              normal: {
                show: true,
                position: "center",
                color: "#4c4a4a",
                formatter: this.preData.countLength,
                rich: {
                  totalText: {
                    fontSize: 14,
                    fontFamily: "Microsoft YaHei",
                    color: "#1F96FA",
                  },
                },
              },
              emphasis: {
                show: true,
              },
            },
          },
        ],
      };
    },
  },
  components: {},
  watch: {
    chartPieOption: {
      handler(newValue) {
        let myChart = echarts.getInstanceByDom(this.$refs.chart);
        // 根据条件设置颜色
        if (this.chartPieOption.series[0].data.every((item) => item.value === 0)) {
          this.chartPieOption.series[0].color = ["#cccccc"]; // 设置为灰色
        }
        myChart.setOption(this.chartPieOption, true);
      },
    },
  },
  mounted() {
    // 根据条件设置颜色
    let myChart = echarts.getInstanceByDom(this.$refs.chart);
    if (this.chartPieOption.series[0].data.every((item) => item.value === 0)) {
      this.chartPieOption.series[0].color = ["#cccccc"]; // 设置为灰色
    }
    if (myChart == null) {
      myChart = echarts.init(this.$refs.chart);
    }
    myChart.setOption(this.chartPieOption, true);
  },
};
</script>

<style lang="scss" scoped></style>
